// Fichier : SyntheseSession.js (modifié et simplifié)
import React, { useState, useEffect, useMemo } from 'react';
// import ShowTopContribution from './ShowTopContribution'; // Semble inutilisé, peut être enlevé
import { PodiumModal } from '../composants/Modal';
import AllContainers from '../composants/AllContainers';

const romanNumerals = ["I", "II", "III", "IV", "V", "VI"];
const alphabet = ['a', 'b', 'c', 'd'];

const SyntheseSession = ({ 
  sujet, 
  premieres_contributions, 
  contribution_actuelle = null, 
  // setModalContent, setModalTitle, setShowModal sont gérés par PodiumModal
  setPrefixNext = false, 
  parametres, 
  type, 
  // redactionLongue et redactionLonguePourTop ne sont plus nécessaires
  // car l'affichage est maintenant unifié.
  resultatFinal = false 
}) => {
  const [showPodiumModal, setShowPodiumModal] = useState(false);
  const [selectedContributions, setSelectedContributions] = useState([]);
  
  // La logique de parsing des paramètres reste ici
  const [parties, setParties] = useState(0);
  const [sousparties, setSousparties] = useState(0);

  useEffect(() => {
    if (type === "plan") {
      const parsedParametres = typeof parametres === 'string' ? JSON.parse(parametres) : parametres;
      setParties(parsedParametres.parties || 0);
      setSousparties(parsedParametres.sousparties || 0);
    }
  }, [parametres, type]);

  const sortedContributions = useMemo(() => {
    return [...premieres_contributions].sort((a, b) => a.phase - b.phase);
  }, [premieres_contributions]);

  // La logique de préfixe pour la contribution actuelle reste ici
  const getPrefixForNext = (index) => {
    if (type === "plan") {
      const partieIndex = Math.floor(index / (sousparties + 1));
      const souspartieIndex = index % (sousparties + 1);

      if (souspartieIndex === 0) {
        return `${romanNumerals[partieIndex]}.`;
      }
      return `${alphabet[souspartieIndex - 1]}.`;
    }
    return `${index + 1}.`;
  };

  const handleShowPodium = (contributions) => {
    setSelectedContributions(contributions);
    setShowPodiumModal(true);
  };

  // La fonction de rendu est maintenant très simple !
  const renderContributions = () => {
    // Cas spécial pour un seul résultat final en mode rédaction.
    // On peut aussi intégrer ce style dans AllContainers/ContributionItem
    // si on veut qu'il soit 100% cohérent.
    if (type === "redaction" && resultatFinal && premieres_contributions.length === 1) {
       return (
         <AllContainers 
            contributions={sortedContributions}
            onShowPodium={handleShowPodium}
            type={type}
         />
       );
    }
    
    // Dans tous les autres cas, on utilise AllContainers.
    return (
      <AllContainers 
        contributions={sortedContributions}
        onShowPodium={handleShowPodium}
        type={type}
        parties={parties}
        sousparties={sousparties}
      />
    );
  };

  return (
    <div>
      <div className="mb-4">
        <div className="flex items-center gap-2 text-lg">
          <span className="text-primary">📝</span>
          <span className="font-semibold">Sujet :</span>
          <span>{sujet}</span>
        </div>
      </div>
      
      {sortedContributions.length > 0 && (
        <div className="mb-4">
          {renderContributions()}
        </div>
      )}
      
      {setPrefixNext && (
        <>
          <hr className="border-border-color my-4" />
          <div 
            className={`current-contribution p-4 rounded-lg border-2 border-dashed ${contribution_actuelle ? 'border-primary bg-primary-light' : 'border-warning bg-warning text-center'}`}
            style={{
              marginLeft: type === "plan" && premieres_contributions.length % (sousparties + 1) !== 0 ? '1.5rem' : '0'
            }}
          >
            <div className={`flex items-center gap-2 ${!contribution_actuelle ? 'justify-center text-warning' : ''}`}>
              {contribution_actuelle ? (
                <>
                  <span className="text-primary font-semibold">
                    {getPrefixForNext(premieres_contributions.length)}
                  </span>
                  <span className="font-medium">{contribution_actuelle}</span>
                  <span className="text-primary">✨</span>
                </>
              ) : (
                <>
                  <span>⏳</span>
                  <span className="font-medium">
                    {getPrefixForNext(premieres_contributions.length)}
                    {" "}(Aucune contribution)
                  </span>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {showPodiumModal && (
        <PodiumModal
          contributions={selectedContributions}
          onClose={() => setShowPodiumModal(false)}
          type={type}
        />
      )}
    </div>
  );
};

export default SyntheseSession;